// https://github.com/quangbuule/redux-example/blob/master/src/js/lib/createReducer.js
import * as Immutable from 'immutable';

export default function createReducer(initialState, handlers) {
  return (state = initialState, action) => {
    if (!Immutable.Map.isMap(state) && !Immutable.List.isList(state)) {
      state = Immutable.fromJS(state);
    }

    const handler = handlers[action.type];

    if (!handler) {
      return state;
    }

    state = handler(state, action);

    if (!Immutable.Map.isMap(state) && !Immutable.List.isList(state)) {
      throw new TypeError('Reducers must return Immutable objects.');
    }

    return state;
  };
}
